import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Loader } from '@huggg/react-components';

import {
  fetchHugggs,
  getAllhugggs,
  getHasLoaded,
  getIsLoading,
} from 'redux/modules/hugggs';
import { clearHuggg, fetchHuggg } from 'redux/modules/huggg';

import HugggList from './HugggList';

export const HugggListContainer = (props) => {
  const { clearHuggg, fetchHuggg, fetchHugggs, hugggs, hasLoaded, isLoading } =
    props;

  useEffect(() => {
    clearHuggg();
    if (!hugggs.length && !hasLoaded) {
      fetchHugggs();
    }
  }, [hugggs.length, fetchHugggs, hasLoaded, clearHuggg]);

  return (
    <>
      {isLoading && <Loader />}

      <HugggList
        hugggs={hugggs}
        fetchHuggg={fetchHuggg}
        hasLoaded={hasLoaded}
        isLoading={isLoading}
      />
    </>
  );
};

HugggListContainer.propTypes = {
  clearHuggg: PropTypes.func.isRequired,
  fetchHuggg: PropTypes.func.isRequired,
  fetchHugggs: PropTypes.func.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  hugggs: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    hugggs: getAllhugggs(state),
    hasLoaded: getHasLoaded(state),
    isLoading: getIsLoading(state),
  };
};

export default connect(mapStateToProps, {
  clearHuggg,
  fetchHuggg,
  fetchHugggs,
})(HugggListContainer);
